import {
  collection,
  doc,
  getDocs,
  query,
  Query,
  QueryDocumentSnapshot,
  setDoc,
  where,
} from 'firebase/firestore';
import { firebaseFunctions, fst as firestore } from '../global/firebase';
import { removeUndefinedAndNaNRecursive } from './utils';
import { httpsCallable } from 'firebase/functions';
export async function firestoreCollectionGet<T>(collectionRef: Query) {
  if (!firestore) return;
  const collectionResult = await getDocs(collectionRef);
  return collectionResult.docs.map((result: QueryDocumentSnapshot) => {
    return { ...(result.data() as T), id: result.id } as T;
  });
}
/**
 * given a path to a Firestore collection, return a new doc id
 * @param collectionPath
 * @returns
 */
export async function firestoreIdGet(collectionPath: string) {
  if (!firestore) return;
  const docRef = doc(collection(firestore, collectionPath));
  return docRef.id;
}

/**
 * query for one Firestore object
 * @param collectionPath
 * @returns
 *
 **/
export async function firestoreQueryDoc<T>(
  collectionPath: string,
  field: string,
  queryString: string,
) {
  if (!firestore) return;
  try {
    const querySnapshot = await getDocs(
      query(
        collection(firestore, collectionPath),
        where(field, '==', queryString),
      ),
    );
    if (querySnapshot.docs?.length) {
      const data = querySnapshot.docs[0].data();
      const id = querySnapshot.docs[0].id;
      return { ...data, id } as T;
    }
    throw new Error('Document not found in Firestore');
  } catch (error) {
    console.error('Error getting documents: ', error);
    return {} as T;
  }
}

export async function firestoreUpdateDoc(collectionPath: string, updateObject) {
  if (!firestore) return;
  updateObject.id = updateObject.id
    ? updateObject.id
    : await firestoreIdGet(collectionPath);
  const docRef = doc(collection(firestore, collectionPath), updateObject.id);

  await setDoc(docRef, removeUndefinedAndNaNRecursive(updateObject), {
    merge: true,
  });
  return updateObject;
}
//todo just include translations
export const FirestoreDataTypesToEnglish = {
  workout: 'Workouts',
  workouts: 'Workouts',
  learningLibrary: 'Learning Library',
  studioWorkouts: 'Studio Workouts',
  assessments: 'Assessments',
  meditations: 'Meditations',
  collections: 'Collections',
};

export function getFirestoreDataDate(input) {
  let date;

  // Convert input to Date object
  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'number') {
    date = new Date(input);
  } else if (typeof input === 'string') {
    date = new Date(input);
  } else {
    throw new Error(
      'Invalid input. Please provide a Date, number (milliseconds), or date string.',
    );
  }

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date.');
  }

  // Format the date as ISO string
  const releaseDate = date.toISOString();

  // Get the timestamp in milliseconds
  const releaseTimestamp = date.getTime();

  return {
    releaseDate,
    releaseTimestamp,
  };
}

export async function mergeUidToAuthUser(originalUserUid: string) {
  //callable function here that merges the newly signed in member with the firestore data at this uid
  const mergeUser = httpsCallable<{ mergeUid: string }, string>(
    firebaseFunctions,
    'mergeUidToAuthUser',
  );

  await mergeUser({
    mergeUid: originalUserUid,
  });
}
